/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Tuannd (tuannd@rsupport.com)
 *
 * @description
 *
 * @created at Wed Jun 17 2024
 **/

import * as React from "react";
import * as S from "../emotion";
import { Button, Row, Typography, useModal } from "@/frameworks/designStuff/components";
import { _T } from "@rfice/language";
import { ModalID } from "@/frameworks/core/commons";
import { InviteChatMember } from "@/frameworks/core/components";

export default function EmptyWrapperSection({ children }: { children: React.ReactNode }) {
	const modal = useModal();

	const handleClick = async () => {
		modal.show({
			id: ModalID.INVITE_CHAT_MEMBER,
			content: (
				<InviteChatMember
					chatKind="DM"
					onHide={() => {
						modal.hide(ModalID.INVITE_CHAT_MEMBER);
					}}
				/>
			)
		});
	};

	return (
		<S.Wrapper>
			<Row
				horizonAlign="center"
				verticalAlign="center"
				style={{ width: "100%", justifyContent: "space-between" }}
			>
				<Typography typoSize="Title3" typoColor="neutral_80_100" css={{ padding: "6px 20px" }}>
					{_T("다이렉트 채팅")}
				</Typography>
				<Button.Icon
					name="Add24"
					size="large"
					variant="text"
					onClick={handleClick}
					data-modal="invite-chat-member"
					style={{ margin: "6px 12px" }}
				/>
			</Row>
			<S.EmptyWrap horizonAlign="center" verticalAlign="center">
				{children}
			</S.EmptyWrap>
		</S.Wrapper>
	);
}
